export const displayNameToInitials = (displayName: string) => {
  return displayName
    ?.split(" ")
    ?.filter(name => name?.[0].charAt(0) === name?.[0].charAt(0).toUpperCase())
    ?.slice(0, 2)
    .map(name => name?.[0])
    .join("");
};
